// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pmcc-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.pmcc-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.pmcc-header h2 {
  margin: 0;
}

.pmcc-header button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.pmcc-header button:hover {
  background-color: #0056b3;
}

.error-message {
  background-color: #f8d7da;
  color: #721c24;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.pmcc-form {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 10px;
  font-weight: bold;
}

.leaps-list {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px;
}

.leaps-item {
  display: block;
  padding: 8px;
  margin-bottom: 5px;
  cursor: pointer;
  border-radius: 4px;
}

.leaps-item:hover {
  background-color: #f5f5f5;
}

.leaps-item input {
  margin-right: 10px;
}

.form-actions {
  margin-top: 20px;
}

.form-actions button {
  padding: 10px 20px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.form-actions button:hover {
  background-color: #218838;
}

.form-actions button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pmcc-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.pmcc-table th,
.pmcc-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.pmcc-table thead {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.pmcc-table thead tr {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.pmcc-table th {
  background: transparent;
  color: white;
  font-weight: 600;
  padding: 12px 8px;
  text-align: left;
  font-size: 0.9rem;
  white-space: nowrap;
}

.pmcc-table th.sortable-header {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s ease;
}

.pmcc-table th.sortable-header:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.pmcc-table tbody tr.disabled-row {
  opacity: 0.5;
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.pmcc-table tbody tr.disabled-row:hover {
  background-color: #f5f5f5;
}

.pmcc-table tr:hover {
  background-color: #f5f5f5;
}

.btn-edit {
  padding: 5px 10px;
  background-color: #ffc107;
  color: #000;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 5px;
}

.btn-edit:hover {
  background-color: #e0a800;
}

.btn-close {
  padding: 5px 10px;
  background-color: #ff9800;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 5px;
}

.btn-close:hover {
  background-color: #f57c00;
}

.btn-delete {
  padding: 5px 10px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-delete:hover {
  background-color: #c82333;
}

.no-data {
  text-align: center;
  padding: 40px;
  color: #666;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.leaps-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.used-badge {
  color: #dc3545;
  font-size: 0.9em;
  margin-left: 5px;
}

.pmcc-details {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.pmcc-info {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
}

.pmcc-info p {
  margin: 10px 0;
}

.pmcc-summary {
  margin-bottom: 30px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.pmcc-summary h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #333;
}

.summary-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

.summary-stat {
  display: flex;
  flex-direction: column;
  padding: 10px;
  background: white;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.stat-label {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 5px;
}

.stat-value {
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
}

.stat-value.pnl-positive {
  color: #28a745;
}

.stat-value.pnl-negative {
  color: #dc3545;
}

.stat-value.pnl-unrealized {
  color: #ff8c00;
}

.leaps-section {
  margin-top: 20px;
}

.leaps-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.leaps-header h3 {
  margin: 0;
}

.btn-add-leaps {
  padding: 8px 16px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-add-leaps:hover {
  background-color: #218838;
}

.leaps-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.leaps-table th,
.leaps-table td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.leaps-table th {
  background-color: #f8f9fa;
  font-weight: bold;
}

.btn-remove {
  padding: 5px 10px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-remove:hover {
  background-color: #c82333;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #ddd;
}

.modal-header h3 {
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  color: #000;
}

.modal-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1 1;
}

.modal-footer {
  padding: 20px;
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.modal-footer button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.modal-footer button:first-child {
  background-color: #6c757d;
  color: white;
}

.modal-footer button:first-child:hover {
  background-color: #5a6268;
}

.modal-footer button:last-child {
  background-color: #28a745;
  color: white;
}

.modal-footer button:last-child:hover {
  background-color: #218838;
}

.modal-footer button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pmcc-row-clickable:hover {
  background-color: #e8f4f8 !important;
}

.leaps-row-clickable:hover {
  background-color: #e8f4f8 !important;
}

.leaps-details-section {
  margin-top: 30px;
}

.leaps-details-section h3 {
  margin-bottom: 15px;
}

.leaps-details-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-top: 10px;
  font-size: 0.85rem;
}

.leaps-details-table th,
.leaps-details-table td {
  padding: 6px 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
}

.leaps-details-table th {
  background-color: #f8f9fa;
  font-weight: bold;
  font-size: 0.8rem;
}

.leaps-details-table tr:hover {
  background-color: #f5f5f5;
}

.status-open {
  color: #28a745;
  font-weight: bold;
}

.status-closed {
  color: #6c757d;
  font-weight: bold;
}

.pnl-positive {
  color: #28a745;
  font-weight: bold;
}

.pnl-negative {
  color: #dc3545;
  font-weight: bold;
}

.pnl-unrealized {
  color: #ff8c00;
  font-weight: bold;
}

.expand-button {
  background: #667eea;
  color: white;
  border: none;
  border-radius: 3px;
  width: 24px;
  height: 24px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  margin-right: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

.expand-button:hover {
  background: #5568d3;
}

.leaps-component-row {
  background-color: #f9f9f9;
}

.leaps-component-row td {
  padding-left: 30px;
  padding-top: 4px;
  padding-bottom: 4px;
  font-size: 0.8rem;
  color: #666;
}

.leaps-closed-row {
  background-color: #fff;
}

.leaps-open-row {
  background-color: #fff;
}

.total-row {
  font-size: 0.85rem;
}.total-row td {
  padding: 6px 8px;
}`, "",{"version":3,"sources":["webpack://./src/PMCC.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB,CAAC;EACC,gBAAgB;AAClB","sourcesContent":[".pmcc-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.pmcc-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.pmcc-header h2 {\n  margin: 0;\n}\n\n.pmcc-header button {\n  padding: 10px 20px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.pmcc-header button:hover {\n  background-color: #0056b3;\n}\n\n.error-message {\n  background-color: #f8d7da;\n  color: #721c24;\n  padding: 12px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.pmcc-form {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 10px;\n  font-weight: bold;\n}\n\n.leaps-list {\n  max-height: 400px;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 10px;\n}\n\n.leaps-item {\n  display: block;\n  padding: 8px;\n  margin-bottom: 5px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.leaps-item:hover {\n  background-color: #f5f5f5;\n}\n\n.leaps-item input {\n  margin-right: 10px;\n}\n\n.form-actions {\n  margin-top: 20px;\n}\n\n.form-actions button {\n  padding: 10px 20px;\n  background-color: #28a745;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.form-actions button:hover {\n  background-color: #218838;\n}\n\n.form-actions button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.pmcc-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.pmcc-table th,\n.pmcc-table td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n.pmcc-table thead {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.pmcc-table thead tr {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.pmcc-table th {\n  background: transparent;\n  color: white;\n  font-weight: 600;\n  padding: 12px 8px;\n  text-align: left;\n  font-size: 0.9rem;\n  white-space: nowrap;\n}\n\n.pmcc-table th.sortable-header {\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n}\n\n.pmcc-table th.sortable-header:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.pmcc-table tbody tr.disabled-row {\n  opacity: 0.5;\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.pmcc-table tbody tr.disabled-row:hover {\n  background-color: #f5f5f5;\n}\n\n.pmcc-table tr:hover {\n  background-color: #f5f5f5;\n}\n\n.btn-edit {\n  padding: 5px 10px;\n  background-color: #ffc107;\n  color: #000;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-right: 5px;\n}\n\n.btn-edit:hover {\n  background-color: #e0a800;\n}\n\n.btn-close {\n  padding: 5px 10px;\n  background-color: #ff9800;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-right: 5px;\n}\n\n.btn-close:hover {\n  background-color: #f57c00;\n}\n\n.btn-delete {\n  padding: 5px 10px;\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.btn-delete:hover {\n  background-color: #c82333;\n}\n\n.no-data {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.leaps-item.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.used-badge {\n  color: #dc3545;\n  font-size: 0.9em;\n  margin-left: 5px;\n}\n\n.pmcc-details {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.pmcc-info {\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #ddd;\n}\n\n.pmcc-info p {\n  margin: 10px 0;\n}\n\n.pmcc-summary {\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n}\n\n.pmcc-summary h3 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  color: #333;\n}\n\n.summary-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 15px;\n}\n\n.summary-stat {\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  background: white;\n  border-radius: 4px;\n  border: 1px solid #e0e0e0;\n}\n\n.stat-label {\n  font-size: 0.9rem;\n  color: #666;\n  margin-bottom: 5px;\n}\n\n.stat-value {\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: #333;\n}\n\n.stat-value.pnl-positive {\n  color: #28a745;\n}\n\n.stat-value.pnl-negative {\n  color: #dc3545;\n}\n\n.stat-value.pnl-unrealized {\n  color: #ff8c00;\n}\n\n.leaps-section {\n  margin-top: 20px;\n}\n\n.leaps-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.leaps-header h3 {\n  margin: 0;\n}\n\n.btn-add-leaps {\n  padding: 8px 16px;\n  background-color: #28a745;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.btn-add-leaps:hover {\n  background-color: #218838;\n}\n\n.leaps-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n}\n\n.leaps-table th,\n.leaps-table td {\n  padding: 10px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n.leaps-table th {\n  background-color: #f8f9fa;\n  font-weight: bold;\n}\n\n.btn-remove {\n  padding: 5px 10px;\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.btn-remove:hover {\n  background-color: #c82333;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #ddd;\n}\n\n.modal-header h3 {\n  margin: 0;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-close:hover {\n  color: #000;\n}\n\n.modal-body {\n  padding: 20px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.modal-footer {\n  padding: 20px;\n  border-top: 1px solid #ddd;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.modal-footer button {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.modal-footer button:first-child {\n  background-color: #6c757d;\n  color: white;\n}\n\n.modal-footer button:first-child:hover {\n  background-color: #5a6268;\n}\n\n.modal-footer button:last-child {\n  background-color: #28a745;\n  color: white;\n}\n\n.modal-footer button:last-child:hover {\n  background-color: #218838;\n}\n\n.modal-footer button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.pmcc-row-clickable:hover {\n  background-color: #e8f4f8 !important;\n}\n\n.leaps-row-clickable:hover {\n  background-color: #e8f4f8 !important;\n}\n\n.leaps-details-section {\n  margin-top: 30px;\n}\n\n.leaps-details-section h3 {\n  margin-bottom: 15px;\n}\n\n.leaps-details-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  margin-top: 10px;\n  font-size: 0.85rem;\n}\n\n.leaps-details-table th,\n.leaps-details-table td {\n  padding: 6px 8px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n  white-space: nowrap;\n}\n\n.leaps-details-table th {\n  background-color: #f8f9fa;\n  font-weight: bold;\n  font-size: 0.8rem;\n}\n\n.leaps-details-table tr:hover {\n  background-color: #f5f5f5;\n}\n\n.status-open {\n  color: #28a745;\n  font-weight: bold;\n}\n\n.status-closed {\n  color: #6c757d;\n  font-weight: bold;\n}\n\n.pnl-positive {\n  color: #28a745;\n  font-weight: bold;\n}\n\n.pnl-negative {\n  color: #dc3545;\n  font-weight: bold;\n}\n\n.pnl-unrealized {\n  color: #ff8c00;\n  font-weight: bold;\n}\n\n.expand-button {\n  background: #667eea;\n  color: white;\n  border: none;\n  border-radius: 3px;\n  width: 24px;\n  height: 24px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  margin-right: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n}\n\n.expand-button:hover {\n  background: #5568d3;\n}\n\n.leaps-component-row {\n  background-color: #f9f9f9;\n}\n\n.leaps-component-row td {\n  padding-left: 30px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  font-size: 0.8rem;\n  color: #666;\n}\n\n.leaps-closed-row {\n  background-color: #fff;\n}\n\n.leaps-open-row {\n  background-color: #fff;\n}\n\n.total-row {\n  font-size: 0.85rem;\n}.total-row td {\n  padding: 6px 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
